import { DialogCloseError, DialogCloseResult } from 'aurelia-dialog';
import { autoinject, newInstance, PLATFORM } from 'aurelia-framework';
import { ValidationController } from 'aurelia-validation';

import { BaseDialog, BaseDialogModel } from '~/components/dialog/base-dialog';
import { FieldModel } from '~/models/form-model';
import { JQueryHelper } from '~/utils/jquery-helper';

export interface MaasGetDialogModel extends BaseDialogModel {
	fieldModel: FieldModel;
}

/**
 * The following end-to-end test covers this dialog class.
 * - C3486062 should allow fund admin user to raise MAAS-GET requests for a selected member
 */
@autoinject
export class MaasGetDialog extends BaseDialog<MaasGetDialogModel> {
	constructor(
		@newInstance() readonly validationController: ValidationController,
		...rest
	) {
		super(...rest);
		PLATFORM.moduleName('./maas-get-dialog');
	}

	public activate(model: MaasGetDialogModel): Promise<MaasGetDialogModel> {
		return super.activate(model).then(() => {
			this.model.dialogSize = BaseDialog.DialogSize.SMALL;
			return this.model;
		});
	}

	protected attached() {
		super.attached();
		JQueryHelper.focusFirstModifiableInput(this.jQueryElement);
	}

	protected deactivate(result: DialogCloseResult | DialogCloseError) {
		super.deactivate(result);
		if (!result.wasCancelled) {
			result.output = this.model;
		}
	}
}
